module.exports = __webpack_public_path__ + "media/images/mcn-logo-6049289f0d88abac25c0096ff72a76fd.png";